import { useEffect, useState } from 'react';
import { getSsrData } from '../libs/ssrData';
import type { MagHistorico, MesMag } from '../helpers/magHistoricoHelper';

/**
 * Histórico mensual del Mercado de Cañuelas (public/mag-historico.json, armado
 * en el build por scripts/build-mag-historico.mjs). En el render estático viene
 * precargado vía ssrData, así la serie queda escrita en el HTML. Sin archivo o
 * vacío devuelve [] y /historico-precios arranca en los remates.
 */
export function useMagHistorico(): { meses: MesMag[]; cargando: boolean } {
  const [meses, setMeses] = useState<MesMag[]>(() => getSsrData<MagHistorico>('magHistorico')?.meses ?? []);
  const [cargando, setCargando] = useState(() => !getSsrData('magHistorico'));

  useEffect(() => {
    let activo = true;
    (async () => {
      try {
        const base = process.env.PUBLIC_URL || '';
        const res = await fetch(`${base}/mag-historico.json`, { cache: 'no-cache' });
        if (res.ok) {
          const data = (await res.json()) as MagHistorico;
          if (activo && Array.isArray(data.meses)) setMeses(data.meses);
        }
      } catch {
        /* sin archivo: quedan los remates */
      } finally {
        if (activo) setCargando(false);
      }
    })();
    return () => {
      activo = false;
    };
  }, []);

  return { meses, cargando };
}
